module.exports = "<span data-ng-message=required>*Test type is required</span>";